import { IconButton, useTheme } from '@mui/material';

export interface IconActionButtonProps {
  icon: React.ReactNode;
  onClick: () => void;
  ariaDescription?: string;
  title?: string;
}

export const IconActionButton = (props: IconActionButtonProps) => {
  const theme = useTheme();

  return (
    <>
      <IconButton
        onClick={props.onClick}
        size="large"
        aria-description={props.ariaDescription}
        title={props.title}
        sx={{
          color: theme.palette.text.secondary,
          outline: `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
          height: 48,
          width: 48,
          padding: 1,
        }}
      >
        {props.icon}
      </IconButton>
    </>
  );
};
